import { formatCurrencyForDisplay } from '@utils'
import cn from 'classnames'
import type { ReactNode } from 'react'

import './discountedValue.scss'

interface DiscountedValueProps {
  value: ReactNode
  discountedValue?: ReactNode
  currency?: string
  className?: string
  showDiscount?: boolean
}

export const DiscountedValue = ({
  value,
  discountedValue,
  currency,
  className,
  showDiscount
}: DiscountedValueProps) => {
  if (!value) return null

  const hasDiscount = showDiscount ?? (discountedValue !== undefined && discountedValue !== null)

  return (
    <span className={cn('discounted-value', className)}>
      {hasDiscount ? (
        <>
          <span className='discounted-value-original'>
            {value} {currency && <span className='row-amount-currency'>{formatCurrencyForDisplay(currency)}</span>}
          </span>
          <span className='discounted-value-new'>
            {discountedValue}{' '}
            {currency && <span className='row-amount-currency'>{formatCurrencyForDisplay(currency)}</span>}
          </span>
        </>
      ) : (
        <>
          {value} {currency && <span className='row-amount-currency'>{formatCurrencyForDisplay(currency)}</span>}
        </>
      )}
    </span>
  )
}
